import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import {
  getEmployee,
  getDesignation,
  getApprovaloptions,
  getProfitCenter,
  insertLevelMaster,
  getLevelData,
  deleteDepartments,
  getUsersForLeaval,
} from "../../services/dataService";
import ReactDataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { getSecureItem } from "../../services/SecureStorage";

function LevelMaster() {
  const [data, setData] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [addLevelModal, setAddLevelModal] = useState(false);
  const [Approvaloptions, setApprovaloptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [CommonDatas, setCommonDatas] = useState([]);
  const [levelEntries, setLevelEntries] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState("");
  const [deleteLevals, setdeleteLevals] = useState(null);
  const [isDirect, setIsDirect] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentEntry, setCurrentEntry] = useState({
    Type: "",
    UserId: "",
    UserName: "",
    level: 1,
    ProfitCenterId: "",
    IsDirect: false
  });

  const openModal = (Id) => {
    setdeleteLevals(Id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setdeleteLevals(null);
  };

  const confirmDelete = () => {
    if (deleteLevals) {
      handleDelete(deleteLevals);
    }
    closeModal();
  };

  const UID = getSecureItem("userId");

  const fetchApprovaloptions = async () => {
    try {
      const response = await getApprovaloptions(UID);
      setApprovaloptions(response.data.data);
    } catch (error) {
      console.error("Error fetching approval options:", error);
    }
  };

  const fetchCommonDatas = async () => {
    setLoading(true);
    try {
      const response = await getProfitCenter(UID);
      setCommonDatas(response.data.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    } finally {
      setLoading(false);
    }
  };

  const getEmployeeData = async () => {
    try {
      const response = await getUsersForLeaval(UID);
      if (response?.data) {
        setEmployeeDetails(response.data.data);
      } else {
        console.warn("Response data is empty or undefined.");
      }
    } catch (error) {
      console.error("Error fetching employee details:", error);
    }
  };

  const fetchLevelData = async () => {
    try {
      const response = await getLevelData(UID);
      if (response?.data) {
        setData(response.data.data);
      } else {
        console.warn("Response data is empty or undefined.");
      }
    } catch (error) {
      console.error("Error fetching level data:", error);
    }
  };

  useEffect(() => {
    getEmployeeData();
    fetchLevelData();
    fetchApprovaloptions();
    fetchCommonDatas();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      // For checkbox, update state with checked boolean value
      setCurrentEntry({
        ...currentEntry,
        [name]: checked,
      });
    } else if (name === "employee") {
      const selectedEmployee = employeeDetails.find((emp) => emp.Id === value);

      setCurrentEntry({
        ...currentEntry,
        UserId: value,
        UserName: selectedEmployee ? selectedEmployee.UserName : "",
      });
    } else if (name === "level") {
      setCurrentEntry({
        ...currentEntry,
        level: parseInt(value) || 1,
      });
    } else {
      setCurrentEntry({
        ...currentEntry,
        [name]: value,
      });
    }
  };


  const addEntryToTable = () => {
    const entryExists = levelEntries.some(
      (entry) => entry.UserId === currentEntry.UserId
    );

    if (entryExists) {
      alert("This user is already added to the list");
      return;
    }

    setLevelEntries([...levelEntries, { ...currentEntry, id: Date.now() }]);

    setCurrentEntry({
      ...currentEntry,
      UserId: "",
      UserName: "",
      level: 1,
    });
  };

  const removeEntry = (id) => {
    setLevelEntries(levelEntries.filter((entry) => entry.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (levelEntries.length === 0) {
      alert("Please add at least one entry");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        Id: isEditing ? editId : "",
        UserId: UID,
        ProfitCenterId: currentEntry.ProfitCenterId,
        IsDirect: currentEntry.IsDirect,
        Type: currentEntry.Type,
        levelEntries: levelEntries.map((entry) => ({
          EmployeeId: entry.UserId,
          Level: entry.level,
        })),
      };

      await insertLevelMaster(payload);
      toast.success(isEditing ? "Level data updated successfully" : "Level data saved successfully");

      setLevelEntries([]);
      setAddLevelModal(false);
      setIsEditing(false);
      setEditId("");
      resetForm();
      fetchLevelData();
    } catch (error) {
      console.error("Error saving level data:", error);
      alert("Error saving level data");
    } finally {
      setLoading(false);
    }
  };

  const clearData = () => {
    resetForm();
    setLevelEntries([]);

    if (isEditing) {
      setIsEditing(false);
      setEditId("");
    }
  };

  const resetForm = () => {
    setCurrentEntry({
      Type: "",
      UserId: "",
      UserName: "",
      level: 1,
      ProfitCenterId: "",
    });
  };

  const handleEdit = (row) => {
    setIsEditing(true);
    setEditId(row.Id);
  
    setCurrentEntry({
      Type: row.Type,
      ProfitCenterId: row.ProfitCenterId,
      IsDirect: row.IsDirect || false,  // Add this line
      UserId: "",
      UserName: "",
      level: 1
    });
  
    if (row.levelEntries && Array.isArray(row.levelEntries)) {
      const mappedEntries = row.levelEntries.map(entry => {
        const employeeItem = employeeDetails.find(e => e.Id === entry.EmployeeId);
  
        return {
          id: Date.now() + Math.random(),
          UserId: entry.EmployeeId,
          UserName: employeeItem ? employeeItem.UserName : "Unknown",
          level: entry.Level
        };
      });
  
      setLevelEntries(mappedEntries);
    }
  
    setAddLevelModal(true);
  };

  const handleDelete = async (Id) => {
    const removeData = { Id: Id, TableName: "ApprovalMaster" };
    setLoading(true);
    try {
      await deleteDepartments(removeData, UID);
      fetchLevelData();
    } catch (error) {
      console.error("Error deleting level:", error);
      alert("Error deleting level");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Profit Center",
      selector: (row) => {
        const found = CommonDatas.find((el) => el.Id === row.ProfitCenterId);
        return found ? found.Name : "N/A";
      },
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => {
        const found = Approvaloptions.find((el) => el.Id === row.Type);
        return found ? found.Name : "N/A";
      },
      sortable: true,
    },
    {
      name: "Level",
      selector: (row) => row.levelEntries.length,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => handleEdit(row)}
          >
            <IconEdit />
          </button>

          <button className="bg-danger rounded-[4px] px-10 py-[8px]" onClick={() => openModal(row.Id)}>
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const modalTableColumns = [
    {
      name: "User",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Level",
      selector: (row) => row.level,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => removeEntry(row.id)}
        >
          Remove
        </button>
      ),
    },
  ];

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Level?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container mx-auto p-4">
        <Breadcrumb title="Level Master" />

        <div className="mb-4 flex justify-end">
          <button
            className="btn btn-primary"
            onClick={() => {
              resetForm();
              setLevelEntries([]);
              setIsEditing(false);
              setEditId("");
              setAddLevelModal(true);
            }}
          >
            Add Level
          </button>
        </div>

        <ReactDataTable
          columns={columns}
          data={data}
          pagination
          paginationResetDefaultPage={false}
        />

        {addLevelModal && (
          <>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  {isEditing ? "Edit Level" : "Add Level"}
                  <span className="absolute top-0 right-0">
                    <button
                      className="btn flex items-center justify-center"
                      onClick={() => setAddLevelModal(false)}
                    >
                      ✖
                    </button>
                  </span>
                </h5>

                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Type</label>
                      <select
                        id="Type"
                        name="Type"
                        value={currentEntry.Type}
                        onChange={handleChange}
                        className="form-control"
                        disabled={levelEntries.length > 0 || isEditing}
                      >
                        <option value="">Select Type</option>
                        {Approvaloptions.map((option) => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Profit Center</label>
                      <select
                        id="ProfitCenterId"
                        name="ProfitCenterId"
                        value={currentEntry.ProfitCenterId}
                        onChange={handleChange}
                        className="form-control"
                        disabled={levelEntries.length > 0 || isEditing}
                      >
                        <option value="">Select Profit center</option>
                        {CommonDatas.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>User</label>
                      <select
                        id="employee"
                        name="employee"
                        value={currentEntry.UserId}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Select User</option>
                        {employeeDetails.map((user) => (
                          <option key={user.Id} value={user.Id}>
                            {user.UserName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>DirectApprove</label>
                      <input
                        type="checkbox"
                        name="IsDirect"
                        checked={currentEntry.IsDirect || false}
                        onChange={handleChange}
                      />

                    </div>



                    {currentEntry.UserId && (
                      <div className="grid grid-cols-12 gap-4 col-span-12">
                        <div className="form-group flex col-span-6 flex-col">
                          <label>Level</label>
                          <input
                            type="number"
                            id="level"
                            name="level"
                            value={currentEntry.level}
                            onChange={handleChange}
                            min="1"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group flex col-span-6 items-end">
                          <button
                            type="button"
                            className="btn btn-success w-full"
                            onClick={addEntryToTable}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {levelEntries.length > 0 && (
                    <div className="mt-6">
                      <h6 className="font-medium mb-2">Added Entries</h6>
                      <ReactDataTable
                        columns={modalTableColumns}
                        data={levelEntries}
                        pagination
                        paginationPerPage={5}
                        dense
                      />
                    </div>
                  )}
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    disabled={loading || levelEntries.length === 0}
                  >
                    {loading ? "Loading..." : isEditing ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </div>
            <div
              className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
              onClick={() => setAddLevelModal(false)}
            ></div>
          </>
        )}
      </div>
    </>
  );
}

export default LevelMaster;